import { render, staticRenderFns } from "./aboutUs.vue?vue&type=template&id=249bce87"
import script from "./aboutUs.vue?vue&type=script&lang=js"
export * from "./aboutUs.vue?vue&type=script&lang=js"
import style0 from "./aboutUs.vue?vue&type=style&index=0&id=249bce87&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports